import {
  SlRadio
} from "./chunk.2I4DYSQK.js";
import {
  radio_card_styles_default
} from "./chunk.7JKGHT65.js";
import {
  l as l2
} from "./chunk.SQVLNLTX.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/radio-card/radio-card.ts
var FadvRadioCard = class extends SlRadio {
  constructor() {
    super(...arguments);
    this.variant = "primary";
  }
  get icon() {
    if (!this.shadowRoot)
      return null;
    const iconSlot = this.shadowRoot.querySelector('slot[name="icon"]');
    const slottedElement = [...(iconSlot == null ? void 0 : iconSlot.assignedElements()) || []].find((e2) => e2.slot === "icon");
    return hasTag(slottedElement, "fadv-icon") ? slottedElement : slottedElement == null ? void 0 : slottedElement.querySelector("fadv-icon");
  }
  firstUpdated() {
    setTimeout(() => this.configureIcon());
  }
  checkedChanged() {
    if (!this.icon)
      return;
    if (this.checked) {
      this.icon.foreground = this.variant || "primary";
      this.icon.background = "white";
    } else {
      this.icon.foreground = "white";
      this.icon.background = this.variant || "primary";
    }
  }
  configureIcon() {
    if (!this.icon)
      return;
    this.icon.size = "large";
    this.checkedChanged();
  }
  render() {
    return $`<label part="base" class=${o({
      "radio-card": true,
      "radio-card--checked": this.checked,
      "radio-card--disabled": this.disabled,
      "radio-card--focused": this["hasFocus"],
      "radio-card--primary": !this.variant || this.variant === "primary",
      "radio-card--secondary": this.variant === "secondary",
      "radio-card--tertiary": this.variant === "tertiary"
    })} ><input class="radio-card__input" type="radio" name=${l(this.name)} value=${l(this.value)} .checked=${l2(this.checked)} .disabled=${l2(this.disabled)} aria-hidden="true" @click=${this.handleClick} @blur=${this.handleBlur} @focus=${this.handleFocus} /><span part="control" class="radio-card__control"><slot name="icon"></slot></span><span part="label" class="radio-card__label"><fadv-typography type="label-large" weight="500"><slot></slot></fadv-typography></span></label>`;
  }
};
FadvRadioCard.styles = radio_card_styles_default;
__decorateClass([
  e()
], FadvRadioCard.prototype, "variant", 2);
__decorateClass([
  i(".radio-card__input")
], FadvRadioCard.prototype, "input", 2);
__decorateClass([
  watch("checked")
], FadvRadioCard.prototype, "checkedChanged", 1);
FadvRadioCard = __decorateClass([
  n("fadv-radio-card")
], FadvRadioCard);

export {
  FadvRadioCard
};
